import { animate, inView, scroll } from "motion"

import "./index.css"

let selector = '#div_block-4-7';

scroll(
  animate( selector , {
    y: "200%",
    transform: "scale(4)"
  })
)

console.log("hello")

